
import { supabase } from "@/integrations/supabase/client";

export const setAffiliatedByValue = async (userId: string, affiliateId: string) => {
  try {
    if (!affiliateId) {
      console.log("No affiliate ID found, skipping affiliation update");
      return false;
    }

    console.log(`Attempting to directly set affiliated_by for new user ${userId} to ${affiliateId}`);
    
    const response = await supabase.functions.invoke('debug-referrals', {
      body: {
        userId,
        affiliateId,
        action: "setAffiliation"
      }
    });
    
    if (response.error) {
      console.error("Error setting affiliate directly:", response.error);
      return false;
    }
    
    const result = response.data?.directAction?.success;
    
    if (result) {
      console.log(`Direct affiliation success for user ${userId} with affiliate ${affiliateId}`);
      return true;
    } else {
      console.warn("Direct affiliation failed:", response.data?.directAction?.error);
      return false;
    }
  } catch (error) {
    console.error("Exception during direct affiliation:", error);
    return false;
  }
};
